import React, { useContext } from "react";
import { useNavigate } from "react-router-dom";
import { WalletContext } from "../context/WalletContext";
import logo from "../BitSpendLogo2.png";

export default function Header() {
  const navigate = useNavigate();
  const { selectedWallet, connectWallet, isCorrectNetwork, chainId } =
    useContext(WalletContext);

  const truncateAddress = (addr) => {
    if (!addr) return "";
    // More aggressive truncation for mobile
    return window.innerWidth < 640
      ? `${addr.slice(0, 4)}...${addr.slice(-3)}`
      : `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  };

  const getNetworkName = () => {
    if (!chainId) return "Unknown";
    if (chainId === 31611n || chainId === 31611) return "Mezo";
    if (chainId === 1n || chainId === 1) return "Ethereum";
    if (chainId === 11155111n || chainId === 11155111) return "Sepolia";
    return `Chain ${chainId}`;
  };

  const handleConnect = async () => {
    await connectWallet(false);
  };

  return (
    <header className="w-full flex items-center justify-between py-4 gap-2">
      {/* Logo - Flexible */}
      <h1
        className="text-xl sm:text-2xl font-bold cursor-pointer flex-shrink-0"
        onClick={() => navigate("/")}
      >
        <div className="flex justify-center align-center gap-2" >
          <img src={logo} width={30} height={30} />
          <span className="xs:inline">BitSpend</span>
        </div>
      </h1>

      {/* Right Side - Compact on Mobile */}
      <div className="flex items-center gap-2 sm:gap-3 flex-shrink-0">
        {/* Network Badge - Hide on very small screens, show abbreviated */}
        {selectedWallet && (
          <div
            className={`px-2 sm:px-3 py-1 sm:py-1.5 rounded-lg text-xs font-semibold whitespace-nowrap ${isCorrectNetwork
                ? "bg-green-500/20 text-green-300 border border-green-500/30"
                : "bg-orange-500/20 text-orange-300 border border-orange-500/30"
              }`}
          >
            <span className="hidden sm:inline">
              {isCorrectNetwork ? "✓" : "⚠️"}{" "}
            </span>
            <span className="hidden md:inline">{getNetworkName()}</span>
            <span className="md:hidden">{getNetworkName().slice(0, 4)}</span>
          </div>
        )}

        {/* Wallet Address or Connect Button */}
        {selectedWallet ? (
          <div className="bg-gray-800 px-2 sm:px-4 py-1.5 sm:py-2 rounded-lg sm:rounded-xl text-xs sm:text-sm font-semibold font-mono">
            {truncateAddress(selectedWallet)}
          </div>
        ) : (
          <button
            onClick={handleConnect}
            className="bg-blue-600 hover:bg-blue-700 px-3 sm:px-6 py-1.5 sm:py-2 rounded-lg sm:rounded-xl text-xs sm:text-sm font-bold shadow-lg transition whitespace-nowrap"
          >
            <span className="hidden sm:inline">Connect Wallet</span>
            <span className="sm:hidden">Connect</span>
          </button>
        )}
      </div>
    </header>
  );
}
